
export const loginLinkStyle = {
  color: "lightGrey",
  fontSize: 16,
  padding: 5,
  margin: 5,
  textDecoration: "none",
}